import { v7 as uuidv7 } from "uuid";
import { z } from "zod";
import { projectSchema } from "./project";

export const informationTableSchema = z.object({
  id: z.string().uuid(),
  projectId: projectSchema.shape.id,
  drawingImageId: z.string().uuid(),
  positionX: z.number(),
  positionY: z.number(),
});

export const newInformationTableInputSchema = informationTableSchema.omit({
  id: true,
});

export const editInformationTableInputSchema = informationTableSchema.pick({
  positionX: true,
  positionY: true,
});

export type InformationTable = z.infer<typeof informationTableSchema>;
export type InformationTableInput = z.input<typeof informationTableSchema>;
export type NewInformationTableInput = z.input<typeof newInformationTableInputSchema>;

export const createInformationTable = (input: NewInformationTableInput): InformationTable => {
  return newInformationTable({
    ...input,
    id: uuidv7(),
  });
};

export const newInformationTable = (input: InformationTableInput): InformationTable =>
  informationTableSchema.parse(input);
